import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, FormGroup, ControlLabel, FormControl, HelpBlock, Button, Form, InputGroup, Col } from 'react-bootstrap';
//import ReCAPTCHA from 'react-google-recaptcha';
import UiUtils from '../../../../utils/UiUtils';
import ApiClient from '../../../../utils/ApiClient';
import './SolicitarUsuario.css'


function FieldGroup({ id, label, help, ...props }) {
    return (
        <FormGroup controlId={id}>
            <ControlLabel>{label}</ControlLabel>
            <FormControl {...props} />
            {help && <HelpBlock>{help}</HelpBlock>}
        </FormGroup>
    );
}
function FieldGroupEmail({ value1, value2, onchange1, onchange2 }) {
    return (
        <div>
            <ControlLabel>Mail</ControlLabel>
            <br />

            <FormGroup onChange={onchange1}>


                <FormControl
                    required="true"
                    type="email"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                    maxLength="254"
                    value={value1} />

            </FormGroup>

        </div>
    )
}
function FieldGroupCelular({ value1, value2, onchange1, onchange2 }) {
    return (
        <div>
            <ControlLabel>Celular</ControlLabel>
            <br />
            <Col className="Col-Form-Demo" xs={4}>
                <FormGroup onChange={onchange1}>
                    <InputGroup>
                        <InputGroup.Addon>0</InputGroup.Addon>
                        <FormControl
                            required="true"
                            type="text"
                            pattern="[0-9]{2,4}"
                            placeholder="Caracteristica"
                            value={value1} />
                    </InputGroup>
                </FormGroup>
            </Col>
            <Col className="Col-Form-Demo" xs={8}>
                <FormGroup onChange={onchange2}>
                    <InputGroup>
                        <InputGroup.Addon>15</InputGroup.Addon>
                        <FormControl
                            required="true"
                            type="text"
                            pattern="[0-9]{6,8}"
                            placeholder="Número"
                            value={value2} />
                    </InputGroup>
                </FormGroup>
            </Col>
        </div>
    )
}

class SolicitarUsuario extends Component {

    constructor(props) {
        super(props);
        this.state = {
            nombre: '',
            apellido: '',
            telArea: '',
            telNumero: '',
            //captchaCode: ''
            email: '',
            asociadoNombre: '',
            institutoNombre: '',
            institutoNumero: '',
            asociadoNumero: '',
            //totp: '',
            //uuid: ''
        };
    }

    onNombreChange = (event) => {
        const newValue = event.target.value.replace(/[^a-zA-Z\s]/g, '');
        this.setState({ nombre: newValue });
    }
    onApellidoChange = (event) => {
        const newValue = event.target.value.replace(/[^a-zA-Z\s]/g, '');
        this.setState({ apellido: newValue });
    }
    onAreaChange = (event) => {
        const newValue = event.target.value.replace(/[^0-9]/g, '');
        this.setState({
            telArea: parseInt(newValue)
        });
    }
    onTelefonoChange = (event) => {
        const newValue = event.target.value.replace(/[^0-9]/g, '');
        this.setState({ telNumero: parseInt(newValue) });
    }

    onEmailChange = (event) => {
        this.setState({
            email: event.target.value
        });
    }
    onasociadoNombre = (event) => {
        const newValue = event.target.value.replace(/[^a-zA-Z\s]/g, '');
        this.setState({
            asociadoNombre: newValue
        });
    }
    oninstitutoNombre = (event) => {
        const newValue = event.target.value.replace(/[^a-zA-Z\s]/g, '');
        this.setState({
            institutoNombre: newValue
        });
    }
    oninstitutoNumero = (event) => {
        const newValue = event.target.value.replace(/[^0-9]/g, '');
        this.setState({
            institutoNumero: parseInt(newValue)
        });
    }
    onasociadoNumero = (event) => {
        const newValue = event.target.value.replace(/[^0-9]/g, '');
        this.setState({
            asociadoNumero: parseInt(newValue)
        });
    }
    onTotpChange = (event) => {
        const newValue = event.target.value.replace(/[^0-9]/g, '');
        this.setState({
            totp: newValue
        });
    }
    //Envio totp
    onSendTotp = () => {
        UiUtils.showProgress(true);
        console.log(this.state.totp)
        ApiClient.validarEmail(this.state.totp)
            .then(function (res) {
                if (res.result.info === "OK") {
                    this.setState({
                        uuid: res.result.uuid
                    });
                }
                UiUtils.showProgress(false);
                UiUtils.showAlert("Aviso", "Se ha enviado un código a su email");
            }).catch(function (error) {
                UiUtils.showError(UiUtils.handledError("No se pudo enviar el código"));
            });
    }
    onSendClick = (event) => {
        event.preventDefault();
        var telefonoCompleto = this.state.telArea.toString() + this.state.telNumero.toString();
        const PNF = require('google-libphonenumber').PhoneNumberFormat;
        const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
        const number = phoneUtil.parseAndKeepRawInput(telefonoCompleto, 'AR');
        if (!phoneUtil.isValidNumber(number)) {
            UiUtils.showAlert("Error", "Verifique su celular");
        } else {
            UiUtils.showProgress(true);
            const final = () => {
                UiUtils.showProgress(false);
                this.props.onCerrarSolicitarUsuario();
            }
            ApiClient.crearNuevoUsuario(this.state)
                .then(function (res) {
                    final();
                    if (res.result.info === "OK") {
                        UiUtils.showAlert("Aviso", "Se ha confirmado la solicitud, el ejecutivo de ventas de pondra en contacto con usted.");
                    }
                }).catch(function (error) {
                    final();
                    UiUtils.showError(UiUtils.handledError("No se pudo procesar la solicitud de nuevo usuario"));
                });
        }
    }
    handleSubmit(event) {
        this.onSendClick()
        event.preventDefault();
    }

    render() {
        return (
            <Modal show={this.props.mostrarSolicitarUsuario} onHide={this.props.onCerrarSolicitarUsuario} onEnter={this.onDialogEnter}>
                <Modal.Header closeButton>
                    <Modal.Title>Solicitar usuario y contraseña</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form lang="es" onSubmit={this.onSendClick}  >
                        <FieldGroup
                            id="nombre"
                            type="text"
                            label="Nombre"
                            placeholder=""
                            required="true"
                            value={this.state.nombre}
                            maxLength="80"
                            onChange={this.onNombreChange} />
                        <FieldGroup
                            id="apellido"
                            type="text"
                            label="Apellido"
                            placeholder=""
                            required="true"
                            value={this.state.apellido}
                            maxLength="80"
                            onChange={this.onApellidoChange} />
                        <FieldGroupCelular
                            value1={this.state.telArea}
                            value2={this.state.telNumero}
                            onchange1={this.onAreaChange}
                            onchange2={this.onTelefonoChange} />
                        <FieldGroupEmail
                            value1={this.state.email}
                            onchange1={this.onEmailChange}
                        />

                        <FieldGroup
                            id="asociadoNombre"
                            type="text"
                            label="Nombre del comercio"
                            placeholder=""
                            required="true"
                            value={this.state.asociadoNombre}
                            maxLength="64"
                            onChange={this.onasociadoNombre} />
                        <FieldGroup
                            id="institutoNombre"
                            type="text"
                            label="Centro Comercial al que pertenece"
                            placeholder=""
                            required="true"
                            value={this.state.institutoNombre}
                            maxLength="64"
                            onChange={this.oninstitutoNombre} />
                        <FieldGroup
                            id="institutoNumero"
                            type="text"
                            label="Número de Centro Comercial (N° de Instituto)"
                            placeholder=""
                            required="true"
                            value={this.state.institutoNumero}
                            maxLength="11"
                            onChange={this.oninstitutoNumero} />
                        <FieldGroup
                            id="asociadoNumero"
                            type="text"
                            label="Número de Asociado (N° de comercio asociado al instituto)"
                            placeholder=""
                            required="true"
                            value={this.state.asociadoNumero}
                            maxLength="11"
                            onChange={this.onasociadoNumero} />

                        {/* <FieldGroup
                            id="codigototp"
                            type="number"
                            label="Código del autenticador"
                            placeholder="Debe escribir el código de 6 dígitos para confirmar"
                            required="true"
                            value={this.state.totp}
                            maxLength="11"
                            onChange={this.onTotpChange} />
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <Button className="mb-3 boton-enviar-cod" bsStyle="primary" onClick={this.onSendTotp}>
                                Enviar código
                            </Button>
                        </div> */}
                        <br />
                        <Modal.Footer>
                            <Button bsStyle="secondary" onClick={this.props.onCerrarSolicitarUsuario}>Cancelar</Button>
                            <Button bsStyle="primary" type="submit">Enviar</Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>
            </Modal >
        );
    }
}
SolicitarUsuario.propTypes = {
    mostrarRecuperarClave: PropTypes.bool,
    onCerrarRecuperarClave: PropTypes.func

}
export default SolicitarUsuario;





// WEBPACK FOOTER //
// ./src/scenes/home/components/solicitarusuario/SolicitarUsuario.js